import styled from 'styled-components';

import LoadingWrapper from '../../../CoreWrappers/LoadingWrapper';

export default styled(LoadingWrapper)`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 2rem;
	flex: 1;
	min-height: 0;
`;
